/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from '../types';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
/** Generic input for queries and mutations by id */
export type IdInput = {
  /** Non-empty id of an object or entity */
  id: string;
};

export type CloseCourseMutationVariables = Exact<{
  courseIdInput: Types.IdInput;
}>;


export type CloseCourseMutation = { closeCourse: { course: { id: string } } };


export const CloseCourseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CloseCourse"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"courseIdInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"IDInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"closeCourse"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"courseIdInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"courseIdInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"course"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CloseCourseMutation, CloseCourseMutationVariables>;